import { createAction, props } from '@ngrx/store';
import {LocationStatus} from '@emm/core/models/location-status.model';
import {OperatorLockItem} from '@emm/core/models/operator-lock-item.model';
import {Item} from '@emm/core/models/item.model';


export enum OperatorLocksAction {
    LoadLocationStatuses = '[Operator Locks Management] Load All Location Statuses',
    LoadLocationStatusesSuccess = '[Management API] Load All Location Statuses Success',
    LoadLocationStatusesFailure = '[Management API] Load All Location Statuses Failure',
    LoadItemsByLock = '[Operator Locks Management] Load Items By Lock',
    LoadItemsByLockSuccess = '[Management API] Load Items By Lock Success',
    LoadItemsByLockFailure = '[Management API] Load Items By Lock Failure',
    LoadAllChildItems = '[Operator Locks Management] Load All Child Items From Operator Locks',
    LoadAllChildItemsSuccess = '[Management API] Load All Child Items From Operator Locks Success',
    LoadAllChildItemsFailure = '[Management API] Load All Child Items From Operator Locks Failure',
    OpenAddDialog = '[Operator Locks Management] Open Lock Item Dialog',
    AddChildItem = '[Operator Locks Management] Add Child Item',
    AddChildItemSuccess = '[Management API] Add Child Item Success',
    AddChildItemFailure = '[Management API] Add Child Item Failure',
    RemoveChildItem = '[Operator Locks Management] Remove Child Item',
    RemoveChildItemSuccess = '[Management API] Remove Child Item Success',
    RemoveChildItemFailure = '[Management API] Remove Child Item Failure',
    UpdateStatusMessage = '[Operator Locks Management] Update Status Message',
    UpdateStatusMessageSuccess = '[Management API] Update Status Message Success',
    UpdateStatusMessageFailure = '[Management API] Update Status Message Failure',
}

export const OperatorLocksActions = {
    loadAllLocationStatuses: createAction(OperatorLocksAction.LoadLocationStatuses),
    loadAllLocationStatusesSuccess: createAction(
        OperatorLocksAction.LoadLocationStatusesSuccess,
        props<{ statuses: LocationStatus[] }>()
    ),
    loadAllLocationStatusesFailure: createAction(
        OperatorLocksAction.LoadLocationStatusesFailure,
        props<{ error: any }>()
    ),
    loadItemsByLock: createAction(OperatorLocksAction.LoadItemsByLock, props<{ tag: string }>()),
    loadItemsByLockSuccess: createAction(
        OperatorLocksAction.LoadItemsByLockSuccess,
        props<{ emergencyMappings: OperatorLockItem[] }>()
    ),
    loadItemsByLockFailure: createAction(
        OperatorLocksAction.LoadItemsByLockFailure,
        props<{ error: any }>()
    ),
    loadAllChildItems: createAction(OperatorLocksAction.LoadAllChildItems, props<{ id: string }>()),
    loadAllChildItemsSuccess: createAction(
        OperatorLocksAction.LoadAllChildItemsSuccess,
        props<{ items: Item[] }>()
    ),
    loadAllChildItemsFailure: createAction(OperatorLocksAction.LoadAllChildItemsFailure, props<{ error: any }>()),
    openAddDialog: createAction(OperatorLocksAction.OpenAddDialog),
    addChildItem: createAction(
        OperatorLocksAction.AddChildItem,
        props<{ emergencyTag: string; file: FormData }>()
    ),
    addChildItemSuccess: createAction(OperatorLocksAction.AddChildItemSuccess),
    addChildItemFailure: createAction(OperatorLocksAction.AddChildItemFailure, props<{ error: any }>()),
    removeChildItem: createAction(
        OperatorLocksAction.RemoveChildItem,
        props<{ emergencyTag: string; itemTag: string }>()
    ),
    removeChildItemSuccess: createAction(OperatorLocksAction.RemoveChildItemSuccess),
    removeChildItemFailure: createAction(OperatorLocksAction.RemoveChildItemFailure, props<{ error: any }>()),
    updateStatusMessage: createAction(
        OperatorLocksAction.UpdateStatusMessage,
        props<{ emergencyTag: string; statusMessage: string, active: boolean, subType: string }>()
    ),
    updateStatusMessageSuccess: createAction(OperatorLocksAction.UpdateStatusMessageSuccess),
    updateStatusMessageFailure: createAction(OperatorLocksAction.UpdateStatusMessageFailure, props<{ error: any }>())
};

export const AsyncActions = {
    loadActions: [
        OperatorLocksActions.loadAllLocationStatuses,
        OperatorLocksActions.loadItemsByLock,
        OperatorLocksActions.loadAllChildItems,
        OperatorLocksActions.addChildItem,
        OperatorLocksActions.removeChildItem
    ],
    successActions: [
        OperatorLocksActions.loadAllLocationStatusesSuccess,
        OperatorLocksActions.loadItemsByLockSuccess,
        OperatorLocksActions.loadAllChildItemsSuccess,
        OperatorLocksActions.addChildItemSuccess,
        OperatorLocksActions.removeChildItemSuccess
    ],
    errorActions: [
        OperatorLocksActions.loadAllLocationStatusesFailure,
        OperatorLocksActions.loadItemsByLockFailure,
        OperatorLocksActions.loadAllChildItemsFailure,
        OperatorLocksActions.addChildItemFailure,
        OperatorLocksActions.removeChildItemFailure
    ]
};
